/**
 * Convert host.docker.internal to localhost for display URLs
 * This makes links work properly in local Docker deployments
 */
export function convertDockerHost(url) {
    if (!url) return url;
    return url.replace(/host\.docker\.internal/g, 'localhost');
}

/**
 * Convert API URL to web URL by removing /dsa/api/v1 and converting host.docker.internal
 * This makes links point to the homepage instead of the API endpoint
 */
export function getWebUrl(apiUrl) {
    if (!apiUrl) return null;
    // Remove /dsa/api/v1 if present, and trailing slashes
    let webUrl = apiUrl.replace('/dsa/api/v1', '').replace(/\/+$/, '');
    // Convert host.docker.internal to localhost for display
    webUrl = webUrl.replace(/host\.docker\.internal/g, 'localhost');
    // Ensure it has a protocol
    if (!webUrl.match(/^https?:\/\//)) {
        webUrl = `http://${webUrl}`;
    }
    return webUrl;
}

/**
 * Format timestamp for display
 */
export function formatTimestamp(timestamp) {
    if (!timestamp) return null;
    try {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        });
    } catch (e) {
        return timestamp.toString();
    }
}

